export default __webpack_public_path__ + "media/images/twitter-ee9c3225f4a72269f3dd11944f02d44c.svg";